import React from 'react';
import { Paragraph } from '@kaizen/typography';
import styles from './WelcomeScreenSettingsRow.scss';

export interface WelcomeScreenSettingsRowProps {
  icon: JSX.Element;
  children: JSX.Element;
  direction: string;
}

export const WelcomeScreenSettingsRow = ({
  icon,
  children,
  direction,
}: WelcomeScreenSettingsRowProps) => {
  return (
    <div className={styles.SettingsLine}>
      <div className={styles.SettingsIconContainer}>{icon}</div>
      <div className={styles.SettingsTextContainer} dir={direction}>
        <Paragraph variant="body" tag="div">
          {children}
        </Paragraph>
      </div>
    </div>
  );
};
